import { createFeatureSelector, createSelector, props } from '@ngrx/store';
import { State } from './state';
import { IModal } from '@shared/models';

export const getState = createFeatureSelector<State>('ui');

export const getModals = createSelector(
  getState,
  (state: State) => state.modals
);

export const getModal = createSelector(
  getModals,
  (modals: { [id: string]: IModal }, props: { id: string }) =>
    modals && modals[props.id]
);

export const getToasts = createSelector(
  getState,
  (state: State) => state.toasts
);

export const getFeedFilter = createSelector(
  getState,
  (state: State) => state.filters.feed
);

export const getForms = createSelector(
  getState,
  (state: State, props: { id }) => {
    return state.forms && state.forms[props.id];
  }
);



